module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('navigation'), _vm._v(" "), _c('div', {
    staticClass: "box_center",
    attrs: {
      "id": "page_x"
    }
  }, [_c('h2', {
    staticClass: "shadow",
    staticStyle: {
      "float": "left"
    }
  }, [_vm._v("Blog")]), _vm._v(" "), _c('adsense', {
    attrs: {
      "ad-client": "ca-pub-8213113866781504",
      "ad-slot": "7783278999",
      "ad-layout-key": "-8i+1w-dq+e9+ft",
      "ad-format": "fluid"
    }
  }), _vm._v(" "), _c('ul', {
    staticClass: "articles"
  }, _vm._l((_vm.posts), function(post) {
    return _c('li', [_c('div', {
      staticClass: "article"
    }, [_c('a', {
      staticClass: "title_article",
      attrs: {
        "href": "#"
      }
    }, [_vm._v(_vm._s(post.title))]), _vm._v(" "), _c('p', {
      staticClass: "text_article",
      domProps: {
        "innerHTML": _vm._s(post.content)
      }
    }), _vm._v(" "), _c('b', [_vm._v(_vm._s(post.date))])]), _vm._v(" "), _c('div', {
      staticClass: "separator"
    })])
  }))], 1)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-55c7f95a"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/pages/Blog.vue
// module id = 293
// module chunks = 1